export default function(mode = false, plus = 0) {
    return new Promise(resolve => {
        if (!this.validateUsername(this.$refs.username._value)) {
            resolve(false);
        }
        if (!mode) {
            this.loading = true;
        }

        this.userData[this.current].username.value = this.$refs.username._value;
        if (plus) {
            this.userData[this.current].username.value = this.$refs.username._value + plus;
        }

        let form_data = new FormData;
        form_data.append('action', ajax_var.action_check_username);
        form_data.append('username', this.userData[this.current].username.value);
        form_data.append('nonce', ajax_var.nonce);

        axios.post(ajax_var.url, form_data).then((res) => {

            //this.initFloatingLabel();
            if (res.status == 200) {
                if (res.data != false) {
                    this.loading = false;
                    this.errorData.username = "Sorry, this username is already in use. Try something else!";
                    resolve(false);
                } else {
                    this.errorData.username = "";
                    resolve(true);
                }
            } else {
                this.loading = false;
                resolve(false);
            }
        })
        .catch(error => {
            this.loading = false;
            resolve(false);
            console.log(error);
        });
    });
};
